module.exports = __webpack_public_path__ + "img/ncrdir.9afcc587.png";